import { useEffect, useState } from 'react'

import { ApiClient } from '../api/apiClient'
import { setPlanner } from '../Context/commonDispatch'
import { Actions } from '../Context/reducer'
import { ErrorMessage } from '../enums/ErrorMessage'
import { GetHeaderMainMenus, HeaderNavItem } from '../enums/HeaderItems'
import { PlannerName } from '../enums/PlannerNameEnum'
import { IStore } from '../types/IStore'

export default function useComponentInitialization(
  apiClient: ApiClient,
  store: IStore,
  dispatch: React.Dispatch<Actions>,
  plannerName: PlannerName,
  handleError: (message: string, e?: Error) => void,
) {
  const [headerNavigationItems, setHeaderNavigationItems] = useState<
    HeaderNavItem[]
  >([])
  const [isInitialized, setIsInitialized] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (isInitialized) return

    dispatch(setPlanner(plannerName))

    void GetHeaderMainMenus(apiClient, store.storeId, plannerName)
      .then((headerNavItems) => {
        setHeaderNavigationItems(headerNavItems)
      })
      .catch((e) => {
        handleError(ErrorMessage.ProductionView.FailedToLoad, e as Error)
      })
      .finally(() => {
        setIsInitialized(true)
        setIsLoading(false)
      })
  }, [
    apiClient,
    dispatch,
    handleError,
    isInitialized,
    plannerName,
    store.storeId,
  ])

  return {
    headerNavigationItems,
    isLoading,
  }
}
